export default "__VITE_ASSET__C7YXRDP5__"